/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ContractType } from './';
import {
    ContractTypeFromJSON,
    ContractTypeFromJSONTyped,
    ContractTypeToJSON,
} from './';
import type { FixedPriceContractDetailsRequest } from './';
import {
    FixedPriceContractDetailsRequestFromJSON,
    FixedPriceContractDetailsRequestFromJSONTyped,
    FixedPriceContractDetailsRequestToJSON,
} from './';
import type { UpdateContractRequest } from './';
import {
    UpdateContractRequestFromJSON,
    UpdateContractRequestFromJSONTyped,
    UpdateContractRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateFixedPriceContractRequest
 */
export interface UpdateFixedPriceContractRequest extends UpdateContractRequest {
    /**
     * 
     * @type {FixedPriceContractDetailsRequest}
     * @memberof UpdateFixedPriceContractRequest
     */
    details: FixedPriceContractDetailsRequest;
}

/**
 * Check if a given object implements the UpdateFixedPriceContractRequest interface.
 */
export function instanceOfUpdateFixedPriceContractRequest(value: object): value is UpdateFixedPriceContractRequest {
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function UpdateFixedPriceContractRequestFromJSON(json: any): UpdateFixedPriceContractRequest {
    return UpdateFixedPriceContractRequestFromJSONTyped(json, false);
}

export function UpdateFixedPriceContractRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFixedPriceContractRequest {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdateContractRequestFromJSONTyped(json, ignoreDiscriminator),
        'details': FixedPriceContractDetailsRequestFromJSON(json['details']),
    };
}

export function UpdateFixedPriceContractRequestToJSON(value?: UpdateFixedPriceContractRequest | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdateContractRequestToJSON(value, true),
        'details': FixedPriceContractDetailsRequestToJSON(value['details']),
    };
}

